import { DoorCycle, DoorStatus } from '@absg/nim-client-shared';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AccessPointService } from 'core.services/access-point/access-point.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

interface buttonView {
  isSpinnerShowing: boolean;
  isButtonDisabled: boolean;
  isAccessPointLocked: boolean;
  isAccessPointUnlocked: boolean;
  isAccessPointOpen: boolean;
  idDoesNotMatch: boolean;
  isVirtual: boolean;
  isSimulatedMode: boolean;
}

@Component({
  selector: '[nc-reopen-door-button]',
  templateUrl: './reopen-access-point-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReOpenDoorButtonComponent {
  @Input() set setDoorId(id: number) {
    this.accessPointId = id;
  }
  @Output() buttonClickEvent = new EventEmitter<void>();
  accessPointId = -1;
  vm$: Observable<buttonView>;

  constructor(private accessPointService: AccessPointService) {
    this.vm$ = this.accessPointService.currentDoorProcess.pipe(startWith(new DoorCycle(-1, DoorStatus.Unlocking)),
      map((result) => {
        const vm = {} as buttonView;
        if (result.isVirtual) {
          vm.isButtonDisabled = true;
          vm.isSpinnerShowing = false;
          vm.isAccessPointLocked = false;
          vm.isAccessPointUnlocked = false;
          vm.isAccessPointOpen = false;
          vm.isVirtual = true;
          vm.isSimulatedMode = result.isSimulatedMode;
          return vm;
        }
        if (this.accessPointId === result.accessPointId) {
          vm.isButtonDisabled = result.doorStatus === DoorStatus.Open || result.doorStatus === DoorStatus.Unlocking || result.doorStatus === DoorStatus.Unlocked
            || result.isSimulatedMode;
          vm.isSpinnerShowing = result.doorStatus === DoorStatus.Unlocking;
          vm.isAccessPointLocked = result.doorStatus === DoorStatus.Locked;
          vm.isAccessPointUnlocked = result.doorStatus === DoorStatus.Unlocked;
          vm.isAccessPointOpen = result.doorStatus === DoorStatus.Open;
          vm.idDoesNotMatch = false;
          vm.isSimulatedMode = result.isSimulatedMode;
        } else {
          vm.isButtonDisabled = true;
          vm.isSpinnerShowing = false;
          vm.isAccessPointLocked = false;
          vm.isAccessPointUnlocked = false;
          vm.isAccessPointOpen = false;
          vm.idDoesNotMatch = true;
          vm.isSimulatedMode = false;
        }
        return vm;
      }));
  }

  buttonClicked(isDisabled: boolean): void {
    if (!isDisabled) {
      this.buttonClickEvent.emit();
    }
  }
}
